import styles from '../typography/Text.module.scss';

// Lightweight alternative to Text's built-in `highlight`/`wordsToHighlight`
// props — that mechanism requires its `children` to be a plain string, so it
// can't be used inside TextWithIcon or a plain <span> (both just render
// `{children}` verbatim). This renders the same highlight style without
// requiring a specific wrapping element.
export default function HighlightText({ text, query }) {
  if (!query?.length || typeof text !== 'string') return text;

  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const parts = text.split(new RegExp(`(${escapedQuery})`, 'gi'));

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <span key={index} className={styles.highlight}>
        {part}
      </span>
    ) : (
      part
    ),
  );
}
